import React, { useContext, useState} from 'react';
import Icon from '../../../general-components/icon';
import { AnimationsContext } from './animations-context';

interface Props {
	text: string;
	icon: string;
	rightWidget?: React.JSX.Element;
}

export default function AnimationSectionHeader(props: Props) {
	const {rightWidget = <></>, text, icon} = props;
	return (
		<div className="animation-tab-header">
			<div className="stylepack-animation-label">
				<Icon 
					name={icon}
					color="#E5E4EC"
					size={16}
				/>
				<div className="stylepack-animation-label-text">{text}</div>
			</div>
			{rightWidget}
		</div>
	);
}